import { useState } from "react";
import { trackOrder } from "../../services/orderApi";

const TrackOrder = () => {
  const [form, setForm] = useState({
    order_id: "",
    phone: "",
    email: "",
  });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleTrack = async () => {
    try {
      setError("");

      if (!form.order_id) {
        setError("Order ID is required");
        return;
      }

      const res = await trackOrder(form);

      if (!res?.order) {
        setError("Order not found or details mismatch");
        setResult(null);
        return;
      }

      setResult(res);

    } catch (err) {
      console.error(err);
      setError("Failed to track order");
    }
  };

  return (
    <div className="track-page" style={{ padding: "20px", maxWidth: "500px" }}>

      <h2>📦 Track Your Order</h2>

      <input
        name="order_id"
        placeholder="Order ID (ORD-xxxx)"
        onChange={handleChange}
        style={input}
      />

      <input
        name="phone"
        placeholder="Phone (optional)"
        onChange={handleChange}
        style={input}
      />

      <input
        name="email"
        placeholder="Email (optional)"
        onChange={handleChange}
        style={input}
      />

      <button onClick={handleTrack} style={btn}>
        Track Order
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* ================= ORDER RESULT ================= */}
      {result?.order && (
        <div style={box}>

          <h3>Order Details</h3>

          <p><b>Order ID:</b> {result.order.order_id}</p>
          <p><b>Status:</b> {result.order.status}</p>
          <p><b>Payment:</b> {result.order.payment_status}</p>

          {/* ================= ITEMS ================= */}
          <h4>🛒 Items</h4>

          {result.items?.map((i) => (
            <div key={i.id}>
              {i.product_name} × {i.quantity}
            </div>
          ))}

          {/* ================= STATUS TIMELINE ================= */}
          <h4 style={{ marginTop: "15px" }}>📍 Tracking Timeline</h4>

          {result.status_history?.length > 0 ? (
            result.status_history.map((s) => (
              <div key={s.id} style={timeline}>
                <b>{s.status}</b>
                <p>{s.note}</p>
                <small>
                  {new Date(s.created_at).toLocaleString()}
                </small>
              </div>
            ))
          ) : (
            <p>No tracking updates yet</p>
          )}

        </div>
      )}

    </div>
  );
};

// ================= STYLES =================
const input = {
  width: "100%",
  marginBottom: "10px",
  padding: "10px",
};

const btn = {
  padding: "10px 15px",
  background: "#1e293b",
  color: "#fff",
  border: "none",
  cursor: "pointer",
};

const box = {
  marginTop: "20px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  background: "#fff",
};

const timeline = {
  padding: "8px",
  borderLeft: "3px solid #1e293b",
  marginTop: "10px",
  background: "#f8fafc",
};

export default TrackOrder;